<template>
<div class="chapter">
<div class="inner_page">
<a id="p64"></a>
<p class="center sink">
<b>PART TWO</b>
</p>
<a id="p65"></a>
<h1 class="chaptertitle parttitle">NEW TESTAMENT ORIGINS OF JEW HATRED</h1>
<div class="third">
<div class="full ">
<img alt=" " id="graphic" src="images/graphic.jpg"/></div>
</div>
<p class="follow"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c002.vue?62565858